const scheduleTypeOptions: { [key: string]: string } = {
  'one-time': 'One-Time',
  daily: 'Daily',
  weekly: 'Weekly',
  monthly: 'Monthly',
};

export default scheduleTypeOptions;
